import { TableStructure } from "../../../components/TableStructure";

const eNewsLetters = [
  {
    type: "external",
    href: "https://www.kmcgov.in/KMCPortal/BuildingMbcResolutionViewAction.do?action=search_appeal",
    target: "_blank",
    label: "MBT Cause List",
  },
  { type: "redirect", label: "MBT Judgement" },
];

export const MatHome = () => (
  <TableStructure
    title={false}
    heading={"MAT"}
    list={eNewsLetters}
    leftMenuList={[
      { type: "link", to: "/MatHome", label: "MAT Home", active: true },
    ]}
  />
);
